/**
 * API Data Source enums and select options
 * Shared across Registers and Masters modules.
 */

export const AuthType = Object.freeze({
  None: 0,
  ApiKey: 1,
  BearerToken: 2,
  BasicAuth: 3,
  OAuth2ClientCredentials: 4,
});

export const AuthTypeOptions = [
  { text: 'None', value: AuthType.None },
  { text: 'API Key', value: AuthType.ApiKey },
  { text: 'Bearer Token', value: AuthType.BearerToken },
  { text: 'Basic Auth', value: AuthType.BasicAuth },
  { text: 'OAuth2 (Client Credentials)', value: AuthType.OAuth2ClientCredentials },
];

export const HttpMethod = Object.freeze({
  GET: 'GET',
  POST: 'POST',
});

export const HttpMethodOptions = [
  { text: 'GET', value: HttpMethod.GET },
  { text: 'POST', value: HttpMethod.POST },
];

export const ScheduleFrequency = Object.freeze({
  Manual: 0,
  Hourly: 1,
  Daily: 2,
  Weekly: 3,
  Custom: 4,
});

export const ScheduleFrequencyOptions = [
  { text: 'Manual Only', value: ScheduleFrequency.Manual, icon: 'mdi-hand-back-right' },
  { text: 'Hourly', value: ScheduleFrequency.Hourly, icon: 'mdi-clock-fast' },
  { text: 'Daily', value: ScheduleFrequency.Daily, icon: 'mdi-calendar-today' },
  { text: 'Weekly', value: ScheduleFrequency.Weekly, icon: 'mdi-calendar-week' },
  { text: 'Custom (Cron)', value: ScheduleFrequency.Custom, icon: 'mdi-code-braces' },
];

export const DayOfWeekOptions = [
  { text: 'Sunday', value: 0 },
  { text: 'Monday', value: 1 },
  { text: 'Tuesday', value: 2 },
  { text: 'Wednesday', value: 3 },
  { text: 'Thursday', value: 4 },
  { text: 'Friday', value: 5 },
  { text: 'Saturday', value: 6 },
];

export const PaginationType = Object.freeze({
  None: 0,
  PageNumber: 1,
  Offset: 2,
  CursorBased: 3,
});

export const PaginationTypeOptions = [
  { text: 'None', value: PaginationType.None },
  { text: 'Page Number', value: PaginationType.PageNumber },
  { text: 'Offset / Limit', value: PaginationType.Offset },
  { text: 'Cursor-Based', value: PaginationType.CursorBased },
];

export const ExecutionStatus = Object.freeze({
  Running: 0,
  Success: 1,
  PartialSuccess: 2,
  Failed: 3,
});

export const ExecutionStatusMap = Object.freeze({
  [ExecutionStatus.Running]: { text: 'Running', color: 'info', icon: 'mdi-progress-clock' },
  [ExecutionStatus.Success]: { text: 'Success', color: 'success', icon: 'mdi-check-circle' },
  [ExecutionStatus.PartialSuccess]: { text: 'Partial Success', color: 'orange', icon: 'mdi-alert-circle' },
  [ExecutionStatus.Failed]: { text: 'Failed', color: 'error', icon: 'mdi-close-circle' },
});

export const ExecutionTriggerType = Object.freeze({
  Manual: 0,
  Scheduled: 1,
});

export const DataSourceStatus = Object.freeze({
  Active: 1,
  Paused: 2,
  Error: 3,
});

export const DataSourceStatusOptions = [
  { text: 'Active', value: DataSourceStatus.Active, color: 'success' },
  { text: 'Paused', value: DataSourceStatus.Paused, color: 'warning' },
  { text: 'Error', value: DataSourceStatus.Error, color: 'error' },
];

export function getAuthTypeText(value) {
  const found = AuthTypeOptions.find(o => o.value === value);
  return found ? found.text : '';
}

export function getScheduleFrequencyText(value) {
  const found = ScheduleFrequencyOptions.find(o => o.value === value);
  return found ? found.text : '';
}

export function getDataSourceStatusColor(value) {
  const found = DataSourceStatusOptions.find(o => o.value === value);
  return found ? found.color : 'grey';
}

export function getDataSourceStatusText(value) {
  const found = DataSourceStatusOptions.find(o => o.value === value);
  return found ? found.text : '';
}

export function getExecutionStatusInfo(value) {
  return ExecutionStatusMap[value] || { text: '', color: 'grey', icon: 'mdi-help-circle' };
}
